export class HttpSapErrorModel {
    constructor(
        public key: string,
        public message: string
    ) {}
}
